import { Field, HTMLWrapper } from "@/storybook-components";
import type { Question } from "@/types";

interface SectionQuestionProps {
  question: Question;
}

const SectionQuestion = ({ question }: SectionQuestionProps): JSX.Element => {
  return (
    <Field.Root my={4}>
      <Field.Label>
        <HTMLWrapper html={question.question} />
      </Field.Label>
      {question.descriptor && <HTMLWrapper html={question.descriptor} />}
    </Field.Root>
  );
};

export default SectionQuestion;
